import React, { useState, useContext, useEffect } from "react";
import "../styles/TextGeneration.css";
import dropdownArrow from "../assets/dropdownarrow.png";
import { generateImage } from "../helper";
import { GenerationContext } from "../context/GenerationContext";
import { db } from "../firebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import { Tooltip } from "react-tooltip";
import toolTip from "../assets/tooltip.png";

const TextGeneration = ({ prompt }) => {
  const {
    setText,
    promptValue,
    setPromptValue,
    styleValue,
    setStyleValue,
    aspectRatio,
    setAspectRatio,
    negativePrompt,
    setNegativePrompt,
    cfgValue,
    setCfgValue,
    seedValue,
    setSeedValue,
    stepsValue,
    setStepsValue,
    highResolution,
    setHighResolution,
    setImageText,
  } = useContext(GenerationContext);

  const [cfgError, setCfgError] = useState(false);
  const [styleError, setStyleError] = useState(false);
  const [seedError, setSeedError] = useState(false);
  const [stepsError, setStepsError] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state
  const [points, setPoints] = useState(localStorage.getItem("points") || 0);
  const [user] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const handleCfgChange = (e) => {
    const value = e.target.value;
    setCfgValue(value);
    if (isNaN(value) || value < 3) {
      setCfgError(true);
    } else {
      setCfgError(false);
    }
  };

  const handleSeedChange = (e) => {
    const value = e.target.value;
    setSeedValue(value);
    if (isNaN(value) || value < 1) {
      setSeedError(true);
    } else {
      setSeedError(false);
    }
  };
  useEffect(() => {
    if (!promptValue) {
      setPromptValue(prompt);
    }

    setPoints(localStorage.getItem("points"));
  }, [points]);
  const handleStepsChange = (e) => {
    const value = e.target.value;
    setStepsValue(e.target.value);
    if (isNaN(value) || value < 30) {
      setStepsError(true);
    } else {
      setStepsError(false);
    }
    console.log("helo ", e.target.value);
  };

  const GenerateAction = async () => {
    setPoints(localStorage.getItem("points"));
    console.log(
      "Points in local storagee start: ",
      localStorage.getItem("points")
    );
    if (!styleValue) {
      setStyleError(true);
      return;
    }
    if (!user) {
      alert("User not logged in. Please log in to generate images.");
      return;
    }
    if (points < 2) {
      alert("Not enough points to generate an image.");
      return;
    }

    setLoading(true); // Set loading to true when starting to generate

    try {
      const text = await generateImage(
        promptValue,
        styleValue,
        aspectRatio,
        negativePrompt,
        cfgValue,
        seedValue,
        stepsValue,
        highResolution
      );
      setText(text);
      setImageText("text");

      const newPoints = localStorage.getItem("points") - 2;
      setPoints(newPoints);

      localStorage.setItem("points", newPoints);
      console.log("Updated points:", newPoints);
      console.log("Points in local storage: ", localStorage.getItem("points"));

      const pointsEvent = new CustomEvent("pointsUpdated", {
        detail: { points: newPoints },
      });
      window.dispatchEvent(pointsEvent);

      // Update Firestore
      try {
        const userDocRef = doc(db, "users", user.uid);
        await setDoc(userDocRef, { points: newPoints }, { merge: true });
        console.log("Points updated successfully in Firestore!");
      } catch (error) {
        console.error("Error updating Firestore document:", error);
      }
    } catch (error) {
      console.error("Error generating image:", error);
    } finally {
      setLoading(false); // Set loading to false when done
    }
  };

  return (
    <div className="container12">
      <div className="scrollView">
        <Tooltip id="steps-tooltip" place="left" />
        <h2 className="heading1">Prompt</h2>
        <textarea
          className="inputPrompt"
          placeholder="Prompt"
          value={promptValue}
          onChange={(e) => setPromptValue(e.target.value)}
        />

        <div className="headingContainer">
          <h2 className="heading1">Style ID</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Style ID"
          />
        </div>

        <div className="dropdownContainer">
          {styleError && (
            <div className="errorMessage2">
              Please select a style from the dropdown
            </div>
          )}
          <select
            className="dropdown"
            onChange={(e) => {
              setStyleValue(e.target.value);
              setStyleError(false);
            }}
            value={styleValue}
            required
          >
            <option value="" disabled>
              Style ID
            </option>

            <option value="21">21: Anime</option>
            <option value="29">29: Realistic</option>
            <option value="26">26: Portrait</option>
            <option value="27">27: Imagine V1</option>
            <option value="28">28: Imagine V3</option>
            <option value="30">30: Imagine V4</option>
            <option value="31">31: Imagine V4 (Creative)</option>
            <option value="32">32: Imagine V4.1</option>
            <option value="33">33: Imagine V5</option>
            <option value="39">39: Imagine V6 Alpha</option>
            <option value="34">34: Anime V5</option>
            <option value="122">122: SDXL 1.0</option>
            <option value="128">128: Imagine Turbo</option>
          </select>

          <img
            src={dropdownArrow}
            alt="dropdown arrow"
            className="dropdownIcon"
          />
        </div>

        <div className="headingContainer">
          <h2 className="heading1">Aspect Ratio</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Aspect Ratio"
          />
        </div>
        <div className="dropdownContainer">
          <select
            className="dropdown"
            onChange={(e) => setAspectRatio(e.target.value)}
            value={aspectRatio}
          >
            <option value="" disabled>
              Aspect Ratio
            </option>
            <option value="1:1">1:1</option>
            <option value="3:2">3:2</option>
            <option value="3:4">3:4</option>
            <option value="4:3">4:3</option>
            <option value="16:9">16:9</option>
            <option value="9:16">9:16</option>
          </select>
          <img
            src={dropdownArrow}
            alt="dropdown arrow"
            className="dropdownIcon"
          />
        </div>

        <div className="headingContainer">
          <Tooltip id="steps-tooltip" place="left" />
          <h2 className="heading1">Negative Prompt</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Negative Prompt"
          />
        </div>

        <textarea
          className="inputPrompt"
          placeholder="Negative Prompt"
          value={negativePrompt}
          onChange={(e) => setNegativePrompt(e.target.value)}
        />

        <div className="headingContainer">
          <h2 className="heading1">CFG</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter CFG"
          />
        </div>
        <input
          type="text"
          className={`input ${cfgError ? "errorBorder" : ""}`}
          placeholder="CFG"
          value={cfgValue}
          onChange={handleCfgChange}
        />
        {cfgError && (
          <div className="errorMessage">CFG value min range is 3</div>
        )}

        <div className="headingContainer">
          <h2 className="heading1">Seed</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Seed Value"
          />
        </div>
        <input
          type="text"
          className={`input ${seedError ? "errorBorder" : ""}`}
          placeholder="Seed"
          value={seedValue}
          onChange={handleSeedChange}
        />
        {seedError && (
          <div className="errorMessage">Seed value min range is 1</div>
        )}
        <div className="headingContainer">
          <h2 className="heading1">Steps</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter the steps value (min: 30)"
          />
        </div>
        <input
          type="text"
          className={`input ${stepsError ? "errorBorder" : ""}`}
          placeholder="Steps"
          value={stepsValue}
          onChange={handleStepsChange}
        />
        {stepsError && (
          <div className="errorMessage">Steps value min range is 30</div>
        )}

        <div className="headingContainer">
          <h2 className="heading1">High Res Results</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter High Resoultion"
          />
        </div>
        <div className="dropdownContainer">
          <select
            className="dropdown"
            onChange={(e) => setHighResolution(e.target.value)}
            value={highResolution}
          >
            <option value="" disabled selected>
              High Res Results
            </option>
            <option value="0">0</option>
            <option value="1">1</option>
          </select>
          <img
            src={dropdownArrow}
            alt="dropdown arrow"
            className="dropdownIcon"
          />
        </div>
        <button className="generateButton" onClick={GenerateAction}>
          {loading ? "Generating..." : "Generate"} {/* Change button text */}
        </button>
      </div>
    </div>
  );
};

export default TextGeneration;
